import { User } from "../../../../context";

type State = {
  users: User[];
  add_user_modal: {
    open: boolean;
    user?: User | undefined;
    error?: Error | null | undefined;
  };
};

type Action =
  | {
      type: "USER:ADD";
      user: User;
    }
  | {
      type: "USER:UPDATE";
      email: string;
      user: Partial<User>;
    }
  | {
      type: "USER:DELETE";
      email: string;
    }
  | {
      type: "ADD_USER_MODAL:OPEN";
      user?: User | undefined;
    }
  | {
      type: "ADD_USER_MODAL:CLOSE";
    }
  | {
      type: "ADD_USER_MODAL:ERROR";
      error?: Error | null | undefined;
    }
  | {
      type: "RESET";
      users: User[];
    };

export function init(state: Partial<State> = {}): State {
  return {
    users: state.users || [],
    add_user_modal: state.add_user_modal || {
      open: false,
    },
  };
}

export function reducer(state: State, action: Action) {
  switch (action.type) {
    case "USER:ADD":
      return {
        ...state,
        users: state.users.concat(action.user),
      };
    case "USER:UPDATE":
      return {
        ...state,
        users: state.users.map((user) =>
          user.email === action.email
            ? {
                ...user,
                ...action.user,
              }
            : user
        ),
      };
    case "USER:DELETE":
      return {
        ...state,
        users: state.users.filter((user) => user.email !== action.email),
      };
    case "ADD_USER_MODAL:OPEN":
      return {
        ...state,
        add_user_modal: {
          open: true,
          user: action.user,
        },
      };
    case "ADD_USER_MODAL:CLOSE":
      return {
        ...state,
        add_user_modal: {
          open: false,
        },
      };
    case "ADD_USER_MODAL:ERROR":
      return {
        ...state,
        add_user_modal: {
          ...state.add_user_modal,
          error: action.error,
        },
      };
    case "RESET":
      return init({
        users: action.users,
      });
    default:
      return state;
  }
}
